module.exports = __webpack_public_path__ + "images/柏纳s长图_08-1.jpg?v=62280a53";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_08-1.jpg
 ** module id = 167
 ** module chunks = 1 2
 **/